import { format } from 'date-fns'
import Joi from 'joi'

import { EntityConstants, VehicleEntity } from 'constants/index'
import { BodyType } from 'generated/graphql'

const formattedDate = format(new Date(), 'dd/MM/yy')

export const VehicleSchema = Joi.object({
  registrationNumber: Joi.string().required().max(VehicleEntity.MAX_REGISTRATION_NUMBER_LENGTH),
  dateOfManufacture: Joi.date()
    .allow(null)
    .max(new Date())
    .optional()
    .label('Date of Manufacture')
    .messages({
      'date.max': `{{#label}} must be less than or equal to "${formattedDate}"`,
    }),
  vehicleTypeId: Joi.number().required().label('Vehicle Type ID'),
  manufacturer: Joi.string().allow('').optional().max(VehicleEntity.MAX_MANUFACTURER_LENGTH),
  model: Joi.string().max(VehicleEntity.MAX_MODEL_LENGTH).optional().allow(''),
  colour: Joi.string().max(VehicleEntity.MAX_COLOUR_LENGTH).optional().allow(''),
  insuranceCompany: Joi.string()
    .max(VehicleEntity.MAX_INSURANCE_COMPANY_LENGTH)
    .optional()
    .allow(''),
  policyOrCoverNote: Joi.string()
    .max(EntityConstants.MAX_NOTE_LENGTH)
    .optional()
    .allow('')
    .label('Policy or Cover Note'),
  goodsInTransitExpiryDate: Joi.date()
    .allow(null)
    .min(new Date())
    .optional()
    .label('Goods in Transit Expiry Date')
    .messages({
      'date.min': `{{#label}} must be greater than or equal to  "${formattedDate}"`,
    }),
  insuranceExpiryDate: Joi.date()
    .allow(null)
    .min(new Date())
    .optional()
    .label('Insurance Expiry Date')
    .messages({
      'date.min': `{{#label}} must be greater than or equal to  "${formattedDate}"`,
    }),
  motTestExpiryDate: Joi.date()
    .allow(null)
    .min(new Date())
    .optional()
    .label('MOT Test Expiry Date')
    .messages({
      'date.min': `{{#label}} must be greater than or equal to  "${formattedDate}"`,
    }),
  isRenewalReminder: Joi.boolean().allow(null, '').optional(),
  hasTailLift: Joi.boolean().label('Tail Lift'),
  bodyType: Joi.string()
    .valid(...Object.values(BodyType))
    .required()
    .label('Body Type')
    .invalid(BodyType.NotSpecified)
    .messages({
      'any.only': 'Body type is required',
    }),
  specialServiceIds: Joi.array().items(Joi.number()).optional(),
  isDefault: Joi.boolean().optional().allow(null).default(null).label('Default Vehicle'),
})
